import { createOptionsFrom } from "@/lib/common/Option";

export const FilterOperatorSymbols = {
	NotEqualTo: "!=",
	LessThanOrEqualTo: "<=",
	GreaterThanOrEqualTo: ">=",
	LessThan: "<",
	GreaterThan: ">",
	EqualTo: "="
} as const;

export type FilterOperator = keyof typeof FilterOperatorSymbols;

export const FilterOperatorLabels: Record<FilterOperator, string> = {
	NotEqualTo: "Not equal to",
	LessThanOrEqualTo: "Less than or equal to",
	GreaterThanOrEqualTo: "Greater than or equal to",
	LessThan: "Less than",
	GreaterThan: "Greater than",
	EqualTo: "Equal to"
};

export const FilterOperatorOptions = createOptionsFrom(FilterOperatorLabels);

export const isFilterOperatorNumeric = (operator: FilterOperator): boolean => {
	return operator === "LessThanOrEqualTo"
		|| operator === "GreaterThanOrEqualTo"
		|| operator === "LessThan"
		|| operator === "GreaterThan";
};

export const NonNumericFilterOperatorOptions = createOptionsFrom({
	NotEqualTo: FilterOperatorLabels.NotEqualTo,
	EqualTo: FilterOperatorLabels.EqualTo
});

export const filterOperatorToString = (operator: FilterOperator): string => {
	return FilterOperatorSymbols[operator];
};

export const filterOperatorToWords = (operator: FilterOperator, valueCount: number): string => {
	switch (operator) {
	case "EqualTo":
		return valueCount === 1 ? "is" : "is one of";
	case "NotEqualTo":
		return valueCount === 1 ? "is not" : "is not one of";
	case "LessThan":
		return "is less than";
	case "LessThanOrEqualTo":
		return "is less than or equal to";
	case "GreaterThan":
		return "is greater than";
	case "GreaterThanOrEqualTo":
		return "is greater than or equal to";
	default:
		return "";
	}
};

export const parseFilterOperator = (operator: string): FilterOperator | null => {
	switch (operator) {
	case "!=":
		return "NotEqualTo";
	case "<=":
		return "LessThanOrEqualTo";
	case ">=":
		return "GreaterThanOrEqualTo";
	case "<":
		return "LessThan";
	case ">":
		return "GreaterThan";
	case "=":
		return "EqualTo";
	default:
		return null;
	}
};
